import { Link } from 'react-router-dom';
import { categories as categoriesData } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            探索内容分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            五大核心板块，覆盖亲密关系所需的方方面面
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categoriesData.map((cat, index) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/60 transition-all duration-300 hover:border-primary-200/50 cursor-pointer"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center gap-2">
                  <div className={`w-8 h-8 rounded-lg ${cat.color} flex items-center justify-center`}>
                    <i className={`${cat.icon} text-white text-sm`}></i>
                  </div>
                  <span className="text-white text-sm font-semibold">{cat.name}</span>
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}